module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-menu', {
    attrs: {
      "bottom": "",
      "left": "",
      "offset-y": "",
      "close-on-content-click": false,
      "max-width": "360"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "editor-format-info__button",
          attrs: {
            "icon": "",
            "small": "",
            "color": "secondary",
            "aria-label": "Show editor format",
            "title": "Show editor format"
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', {
          attrs: {
            "small": ""
          }
        }, [_vm._v("mdi-information-outline")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('v-card', {
    staticClass: "editor-format-info"
  }, [_c('v-card-title', {
    staticClass: "editor-format-info__title"
  }, [_vm._v("\n      Expected format\n    ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "editor-format-info__content"
  }, [_vm._v("\n      " + _vm._s(_vm.format) + "\n    ")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1114e1f2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Pairing/CreatorConceptForm/EditorFormatInfo.vue
// module id = 2008
// module chunks = 0